export default "__VITE_ASSET__D614I6x8__"